var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.6673C21 10.5007 19.8333 9.33398 17.5 9.33398C17.1474 9.33398 16.7475 9.33398 16.3335 9.33398C14.4006 9.33398 12.8333 7.76698 12.8333 5.83398V2.33398",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24.5H24.5V14H21V19.25M21 24.5V19.25M21 24.5H3.5V19.8333L7.58333 16.3333L12.25 19.25L16.9167 16.3333L21 19.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 11.6673C24.5 4.66732 19.8333 4.66732 19.8333 4.66732C19.8333 4.66732 24.5 5.25065 24.5 2.33398",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndustry);
export default __webpack_public_path__ + "static/media/icon-industry.d161ba1b49f6f3273ce4473464fd9f74.svg";
export { ForwardRef as ReactComponent };